/** Claves Pro y de producto. Si la sesión aún no trae `sidebarMenu`, estas quedan ocultas. */
const PREMIUM_MENU_KEYS = new Set([
  'pro.donaciones',
  'pro.email',
  'pro.chatbot',
  'product.erp',
]);

const ALLOWED_PATHS: Array<[string, string]> = [
  ['dashboard.general', '/dashboard/general'],
  ['dashboard.suscriptores', '/dashboard/suscriptores'],
  ['dashboard.financiero', '/dashboard/financiero'],
  ['subscribers.cartera', '/subscribers/cartera'],
  ['subscribers.virtualpos', '/subscribers/virtual-pos'],
  ['subscribers.payku', '/subscribers/payku'],
  ['subscribers.mandatos', '/subscribers/mandatos'],
  ['subscribers.donando', '/subscribers/donando'],
  ['management.forecast', '/management/forecast'],
  ['management.presupuesto', '/management/presupuesto'],
  ['management.proyecciones', '/management/proyecciones'],
  ['mantenants.usuarios', '/mantenants/usuarios'],
  ['mantenants.estados', '/mantenants/estados'],
  ['mantenants.bancos', '/mantenants/bancos'],
  ['reports', '/reports'],
  ['settings.usuarios', '/settings/usuarios'],
  ['settings.integrations', '/settings/integrations'],
  ['settings.integration-logs', '/settings/integration-logs'],
  ['pro.donaciones', '/donaciones'],
  ['pro.email', '/email'],
  ['pro.chatbot', '/chatbot'],
  ['product.erp', '/erp'],
];

export function isSidebarKeyAllowed(menu: string[] | undefined, key: string): boolean {
  if (!menu) return !PREMIUM_MENU_KEYS.has(key);
  return menu.includes(key);
}

export function firstAllowedPath(menu: string[] | undefined): string {
  for (const [key, path] of ALLOWED_PATHS) {
    if (isSidebarKeyAllowed(menu, key)) return path;
  }
  return '/profile';
}
